export interface Reference<TType extends ReferenceType = ReferenceType> {
  id: string,
  type: TType
}

export enum ReferenceType {
  AGENT = 'AGENT',
  AGENCY = 'AGENCY',
  CONTACT = 'CONTACT',
  INTENT = 'INTENT',
  JOB_APPLICATION = 'JOB_APPLICATION',
  LEAD = 'LEAD',
  PROPERTY = 'PROPERTY',
  PROSPECT = 'PROSPECT',
  RUMOR = 'RUMOR',
  OFFER = 'OFFER',
  SEARCH_CRITERIA = 'SEARCH_CRITERIA',
  TASK = 'TASK',
  INVOICE = 'INVOICE',
  COMPANY = 'COMPANY',
}
